var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C15.7712 2 17.6566 2.0003 18.8281 3.17188C19.9997 4.34345 20 6.22876 20 10V14C20 17.7712 19.9997 19.6566 18.8281 20.8281C17.6566 21.9997 15.7712 22 12 22H8C4.22876 22 2.34345 21.9997 1.17188 20.8281C0.000302137 19.6566 0 17.7712 0 14V10C0 6.22876 0.000302125 4.34345 1.17188 3.17188C2.34345 2.0003 4.22876 2 8 2H12ZM10 15C8.55533 15 7.14824 15.4465 5.9707 16.2754L5.73828 16.4463C4.51584 17.3843 3.63709 18.7001 3.23828 20.1885C3.09553 20.7218 3.4121 21.2701 3.94531 21.4131C4.47869 21.556 5.02687 21.2394 5.16992 20.7061C5.45479 19.6429 6.08287 18.7032 6.95605 18.0332L7.12207 17.9111C7.96317 17.3191 8.9681 17 10 17L10.2061 17.0039C11.2337 17.0463 12.2253 17.405 13.0439 18.0332L13.2051 18.1621C13.9418 18.7773 14.4861 19.5918 14.7725 20.5078L14.8301 20.7061L14.8613 20.8037C15.0414 21.2773 15.5547 21.5471 16.0547 21.4131C16.5547 21.279 16.8644 20.7884 16.7832 20.2881L16.7617 20.1885L16.6807 19.9111C16.2796 18.6285 15.5179 17.4883 14.4863 16.627L14.2617 16.4463C13.1155 15.5668 11.7269 15.0651 10.2881 15.0059L10 15ZM10 5C7.79086 5 6 6.79086 6 9C6 11.2091 7.79086 13 10 13C12.2091 13 14 11.2091 14 9C14 6.79086 12.2091 5 10 5ZM10 7C11.1046 7 12 7.89543 12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9C8 7.89543 8.89543 7 10 7Z",
    fill: "#222222"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsActive);
export default __webpack_public_path__ + "static/media/ContactsActive.1d7233142de86f709756a24766e7649a.svg";
export { ForwardRef as ReactComponent };